import { render } from "./Kardex.vue?vue&type=template&id=f50adb0a&scoped=true"
import script from "./Kardex.vue?vue&type=script&lang=js"
export * from "./Kardex.vue?vue&type=script&lang=js"

import "./Kardex.vue?vue&type=style&index=0&id=f50adb0a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f50adb0a"]])

export default __exports__